import React from 'react';
import {Row, Col} from 'reactstrap';
import SelectMonth from '@/b2c/PlanDetail/SelectMonth';
import ProviderStatement from '@/b2c/PlanDetail/ProviderStatement';

const Statement = ({
  plan: {
    caId,
    capId,
    stmtMonthOptions,
    providerShortName,
    providerStatementPath,
  },
  skipFormDownload,
}) => (
  <>
    {/* wide */}
    <div className='wide'>
      <Row>
        <Col md='12'>
          {!skipFormDownload && (
            <SelectMonth
              caId={caId}
              capId={capId}
              monthOptions={stmtMonthOptions}
            />
          )}
        </Col>
      </Row>
      <Row>
        <Col md='auto'>
          <ProviderStatement
            providerShortName={providerShortName}
            providerStatementPath={providerStatementPath}
          />
        </Col>
      </Row>
    </div>

    {/* RWD */}
    <div className='narrow'>
      {!skipFormDownload && (
        <SelectMonth
          caId={caId}
          capId={capId}
          monthOptions={stmtMonthOptions}
        />
      )}
      <ProviderStatement
        providerShortName={providerShortName}
        providerStatementPath={providerStatementPath}
      />
    </div>
  </>
);
export default Statement;
